export const DEFAULT_QUESTION_PAGE_SIZE = 50;

export const DECLARED_PROJECTS_PAGE_SIZE = 10;

export const MONITOR_GROUPINGS = ['member', 'board', 'class', 'zilla'] as const;

export type MonitorGrouping = (typeof MONITOR_GROUPINGS)[number];

export const GROUPING_LABEL: Record<MonitorGrouping, string> = {
  member: 'ZM',
  board: 'Board',
  class: 'Class',
  zilla: 'District',
};

export const GROUPING_COLUMN_HEADER: Record<MonitorGrouping, string> = {
  member: 'ZM Name',
  board: 'Board',
  class: 'Class',
  zilla: 'District',
};

export type MonitorScreen = 'member' | 'byBoard' | 'byClass';

export interface MonitorScreenConfig {
  groupBy: MonitorGrouping;
  requiresProject: boolean;
  showDownloadCount: boolean;
}

export const MONITOR_SCREENS: Record<MonitorScreen, MonitorScreenConfig> = {
  member: { groupBy: 'member', requiresProject: true, showDownloadCount: false },
  byBoard: { groupBy: 'board', requiresProject: true, showDownloadCount: false },
  byClass: { groupBy: 'board', requiresProject: false, showDownloadCount: true },
};

export const MONITOR_SCREEN_PATH = {
  member: '/question/download',
  byBoard: '/question/download-by-board',
  byClass: '/question/download-by-class',
} as const satisfies Record<MonitorScreen, string>;

export const MONITOR_SCREEN_PATHS = [
  MONITOR_SCREEN_PATH.member,
  MONITOR_SCREEN_PATH.byBoard,
  MONITOR_SCREEN_PATH.byClass,
] as const;

export type MonitorScreenPath = (typeof MONITOR_SCREEN_PATHS)[number];

export const PROJECT_MANAGEMENT_PATH = '/question/projects';

export const INSTITUTE_PAPERS_ORIGIN_PATHS = [
  ...MONITOR_SCREEN_PATHS,
  PROJECT_MANAGEMENT_PATH,
] as const;

export const INSTITUTE_PAPERS_TITLE = {
  all: 'Institute Papers',
  collectedOnly: 'Collected Papers',
} as const;

export const MONITOR_TAB_IDS = ['summary', 'institutes'] as const;

export type MonitorTabId = (typeof MONITOR_TAB_IDS)[number];

export const PROJECT_TAB_IDS = ['projects', 'assignments', 'institutes'] as const;

export type ProjectTabId = (typeof PROJECT_TAB_IDS)[number];

export type BoardBreakdownGrouping = Extract<MonitorGrouping, 'class' | 'zilla'>;

export const INSTITUTE_LIST_VARIANTS = ['byUser', 'byArea', 'byAreaNew'] as const;

export type InstituteListVariant = (typeof INSTITUTE_LIST_VARIANTS)[number];

export const MONITOR_LEVEL_TITLE = {
  classes: 'Class wise Question Monitor',
  districts: 'District wise Question Monitor',
  assigned: 'Institutes and Subjects Assigned',
  newCollected: 'New Subjects Collected',
  collected: 'Subjects Collected',
} as const;

export const OTHER_MENU_CLASS_SUFFIX = ' (Other)';

export const PROJECT_LOOKUP_PAGE_SIZE = 200;
